import TopLogout from "../components/TopLogout";
import React from "react";
import BottomNav from "../components/BottomNav";

export default function About() {
  return (
    <div style={styles.bg}>

      {/* ⭐ COMPANY LOGO (TOP-LEFT) */}
      <img src="/com_logo.png" alt="Company Logo" style={styles.companyLogo} />

      <div style={styles.overlay}>
        <TopLogout />

        <h1 style={styles.title}>About Project</h1>

        <div style={styles.card}>
          <h2 style={styles.heading}>Smart Agriculture Automation System</h2>

          <p style={styles.text}>
            This project is an IoT-based smart agriculture solution designed to monitor and control
            essential environmental and nutrient parameters in real time.
          </p>

          <h3 style={styles.subHeading}>Monitored Parameters:</h3>
          <ul style={styles.list}>
            <li>TDS (Water Quality)</li>
            <li>pH Level</li>
            <li>NPK (Soil Nutrients)</li>
            <li>Temperature & Humidity</li>
            <li>Light Intensity</li>
          </ul>

          <h3 style={styles.subHeading}>Automated Controls:</h3>
          <ul style={styles.list}>
            <li>Water Pump</li>
            <li>pH Control Motor</li>
            <li>Nutrient Pump</li>
            <li>Irrigation Motor</li>
            <li>Grow Lights</li>
            <li>Humidifier</li>
          </ul>

          <p style={styles.text}>
            All system data is stored in Firebase and visualized through a professional React-based dashboard.
            Users can view live sensor readings, check device status, download daily history reports,
            and manage multiple user accounts.
          </p>
        </div>

      </div>

      <BottomNav />
    </div>
  );
}

/* STYLES */
const styles = {
  bg: {
    backgroundImage: "url('/bg6.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
    width: "100%",
  },

  /* ⭐ NEW LOGO STYLE */
  companyLogo: {
    position: "absolute",
    top: "10px",
    left: "10px",
    width: "140px",
    zIndex: 1000,
  },

  overlay: {
    background: "rgba(0,0,0,0.55)",
    minHeight: "100vh",
    padding: "20px",
    paddingBottom: "90px",
    textAlign: "center",
    color: "white",
  },

  title: {
    fontSize: "34px",
    fontWeight: "bold",
    marginBottom: "25px",
    color: "#a8ff60",
  },

  card: {
    background: "rgba(0,0,0,0.35)",
    borderRadius: "14px",
    padding: "25px",
    width: "92%",
    maxWidth: "700px",
    margin: "auto",
    backdropFilter: "blur(6px)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.45)",
    textAlign: "left",
  },

  heading: {
    fontSize: "22px",
    fontWeight: "700",
    marginBottom: "10px",
    color: "#d4ffbd",
  },

  subHeading: {
    marginTop: "15px",
    marginBottom: "8px",
    fontSize: "18px",
    fontWeight: "600",
    color: "#a8ff60",
  },

  text: {
    fontSize: "15px",
    lineHeight: "22px",
    opacity: 0.9,
    marginBottom: "10px",
  },

  list: {
    listStyle: "disc",
    paddingLeft: "20px",
    lineHeight: "22px",
    fontSize: "15px",
  },
};

/* OPTIONAL HOVER ANIMATION */
setTimeout(() => {
  const sheet = document.styleSheets[0];
  sheet.insertRule(`
    div[style*="rgba(0,0,0,0.35)"]:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 18px rgba(0,0,0,0.55);
      transition: .3s ease;
    }
  `, sheet.cssRules.length);
}, 50);
